<div class="calculator" [ngClass]="theme">
  <div class="instance postd">
    <div>
      <div class="header">
        <h5><img src="/assets/images/postd_tm_logo/SVG/postd_white.svg" /></h5>
      </div>
      <div class="total">
        <label>Total Earned:</label>
        <span class="price">{{ postdSettings.total | currency : 'USD' : 'symbol' }}</span>
      </div>
      <div class="slider" *ngIf="isBrowser">
        <label
          >Price you set:
          <span class="value">{{ postdSettings.cost | currency : 'USD' : 'symbol' }}</span></label
        >
        <ngx-slider
          [options]="postdConfigs.cost"
          [(value)]="postdSettings.cost"
          (userChange)="update($event)"
        ></ngx-slider>
      </div>
      <div class="slider" *ngIf="isBrowser">
        <label
          >Number of views:
          <span class="value">{{ postdSettings.soldDisplay | number : '1.' }}</span></label
        >
        <ngx-slider
          [options]="postdConfigs.sold"
          [(value)]="postdSettings.sold"
          (userChange)="update($event)"
        ></ngx-slider>
      </div>
      <div class="slider">
        <label
          >Creator share: <span class="value">{{ postdSettings.share * 100 }}% Fixed</span></label
        >
      </div>
    </div>
  </div>
  <div class="instance ad-platform">
    <div>
      <div class="header">
        <h5>YouTube</h5>
        <span class="note">Content creators earn a tiny fraction of what advertisers pay.</span>
      </div>
      <div class="total">
        <label>Total Earned:</label>
        <span class="price">{{ adPlatformSettings.total | currency : 'USD' : 'symbol' }}</span>
      </div>
      <div class="slider" *ngIf="isBrowser">
        <label
          >CPM:
          <span class="value">{{
            adPlatformSettings.cpm | currency : 'USD' : 'symbol'
          }}</span></label
        >
        <ngx-slider
          [options]="adPlatformConfigs.cpm"
          [(value)]="adPlatformSettings.cpm"
          (userChange)="update($event)"
        ></ngx-slider>
      </div>
      <div class="slider" *ngIf="isBrowser">
        <label
          >Number of views:
          <span class="value">{{ adPlatformSettings.viewsDisplay | number : '1.' }}</span></label
        >
        <ngx-slider
          [options]="adPlatformConfigs.views"
          [(value)]="adPlatformSettings.views"
          (userChange)="update($event)"
        ></ngx-slider>
      </div>
      <div class="slider" *ngIf="isBrowser">
        <label
          >Creator share:
          <span class="value">{{ adPlatformSettings.share * 100 | number : '1.0-0' }}%</span></label
        >
        <ngx-slider
          [options]="adPlatformConfigs.share"
          [(value)]="adPlatformSettings.share"
          (userChange)="update($event)"
        ></ngx-slider>
      </div>
    </div>
  </div>
</div>
